import { useDispatch, useSelector } from 'react-redux';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Card } from './ui/card';

import { AdressesLabel, IAddresses } from '../modules/addresses/types/Adresses';
import { addressLabel } from '../modules/addresses/libs/addressesLabel';
import { truncate } from '../utils/truncate';
import { useNavigate } from 'react-router-dom';
import { setEditAddress } from '../store/slices/editAddres';
import { useState } from 'react';
import { EditIcon } from '../assets/Edit';
import { t } from 'i18next';
import { DeleteAddressesIcon } from '../assets/DeleteAdresses';
import { Separator } from './ui/separator';
import { DeleteAddressDrawer } from './DeleteAddressDrawer';

import { userSavedAddresses } from '../store/selectors/userAddresses';
import { setSelectedAddress } from '../store/slices/userAddresses';
import { setLocation } from '../store/slices/locationSlice';
type AddressListProps = {
  addresses: IAddresses[];
};

export const UserAddressList = ({ addresses }: AddressListProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const savedAddresses = useSelector(userSavedAddresses);

  const [open, setIsOpen] = useState(false);

  const handleEdit = (addres: IAddresses) => {
    dispatch(setEditAddress(addres));

    navigate(`/adding-address/${addres._id}`);
  };

  const handelOpentDialog = (addres: IAddresses) => {
    dispatch(setEditAddress(addres));
    setIsOpen(true);
  };

  return (
    <>
      <RadioGroup>
        <Card className="pt-[9px] rounded-xl space-y-2 ">
          <div>
            {addresses.map((address, index) => (
              <div key={address._id} className="flex flex-col space-y-[9px] ">
                <div className="flex flex-row justify-between pl-[18px] pr-[9px] items-center gap-x-2">
                  <div
                    className="flex flex-row items-center space-x-[18px] flex-1 min-w-0"
                    onClick={() => {
                      navigate(-1);
                      dispatch(setSelectedAddress(address._id));
                      dispatch(
                        setLocation({
                          latitude: address.location.lat,
                          longitude: address.location.lon,
                        })
                      );
                    }}
                  >
                    <RadioGroupItem
                      isCircular
                      className="shrink-0"
                      value={address._id}
                      checked={String(address._id) === String(savedAddresses)}
                    />
                    <div className="flex flex-col min-w-0 w-full justify-center pt-2">
                      <p className="text-body-base-regular text-text-primary">
                        {address.label_type === AdressesLabel.OTHERS
                          ? address.label_value
                            ? address.label_value
                            : truncate(address.title, 25)
                          : addressLabel(t)[
                              address.label_type as AdressesLabel
                            ]}
                      </p>
                      {/* Адрес целиком, с переносом: обрезка прятала дом и
                          подъезд — то, ради чего адрес и открывают. */}
                      <p className="text-body-sm-regular text-text-tertiary break-words">
                        {address.title}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-row space-x-2 items-center shrink-0">
                    <div onClick={() => handleEdit(address)}>
                      <EditIcon className="text-text-icon-tertiary" />
                    </div>
                    {addresses.length > 1 && (
                      <div onClick={() => handelOpentDialog(address)}>
                        <DeleteAddressesIcon className="text-fill-danger" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="pl-14">
                  {index !== addresses.length - 1 && (
                    <Separator className="w-full" />
                  )}
                </div>
              </div>
            ))}
          </div>
        </Card>
      </RadioGroup>

      <DeleteAddressDrawer open={open} setIsOpen={setIsOpen} />
    </>
  );
};
